import React from "react";
import { usePageData } from "../PageDataProvider";
import Banners from "./Banners";

export default function BottomBanners() {
    const pageData = usePageData();

    const banners = pageData?.cart?.topBanners ?? null;

    if (banners == null || banners.length === 0) {
        return null;
    }

    return <Banners banners={banners} />;
}
